import { EProjectStructure } from '../store/ducks/fabrication-projects/types';

export const projectPavementsNeedRange = (
  projectStructures: string[]
): boolean => {
  return projectStructures.some((s) =>
    [
      EProjectStructure.PILLAR_PROJECT,
      EProjectStructure.STAIRS_PROJECT
    ].includes(s as EProjectStructure)
  );
};
